import { Component, OnInit } from '@angular/core';
// component ok
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.sass'],
  standalone: true,
  imports: []
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
